// extracted by mini-css-extract-plugin
module.exports = {"item_container":"FJVideoDetails_item_container__23HL9","title":"FJVideoDetails_title__15GzV","video_box":"FJVideoDetails_video_box__3_9P2"};